const Branch = require('@/lib/Branches/Branch');
const Company = require('@/lib/Companies/Company');
const { fromJson, toInt, toNullableString, toString } = require('@/functions/transform');

/**
 * Representation of a single user.
 * This is the beginnings of separating the User model from the UserService so there is a lot of duplication between
 * the two. Eventually the info about the user will live here and UserService will only contain a User model instead
 * of all the properties.
 *
 * @constructor
 */
const User = function () {
    /**
     * @type {?number}
     */
    this.ID = null;

    /**
     * @type {?string}
     */
    this.apiKey = null;

    /**
     * @type {?string}
     */
    this.entraIDToken = null;

    /**
     * @type {Branch[]}
     */
    this.branches = [];

    /**
     * @type {?Company}
     */
    this.company = null;

    /**
     * @type {?object}
     */
    this.paymentTerminalConfig = null;

    /**
     * @type {?number}
     */
    this.usergroupID = null;

    /**
     * @type {?string}
     */
    this.username = null;

    /**
     * @type {string}
     */
    this.publicFacingName = '';
};

User.prototype = {
    getHydrationMap() {
        return {
            apiKey: toString,
            branches: {
                modelCollection: Branch,
            },
            company: {
                field: ['company', 'companies'],
                model: Company,
            },
            entraIDToken: toNullableString,
            ID: {
                field: ['userID', 'ID'],
                transform: toInt,
            },
            paymentTerminalConfig: fromJson,
            publicFacingName: toString,
            usergroupID: toInt,
            username: toString,
        };
    },

    /**
     * @param {number} branchID
     *
     * @return {?Branch}
     */
    getBranchByID(branchID) {
        return this.branches.find((b) => b.ID === branchID) || null;
    },

    /**
     * @returns {Branch|null}
     */
    getFirstActiveBranch() {
        return this.branches.find((b) => b.status === 'Active') || null;
    },

    toSeller() {
        const seller = new User();
        seller.ID = this.ID;
        seller.username = this.username;
        seller.publicFacingName = this.publicFacingName;

        return seller;
    },
};

module.exports = User;
